import { useStores } from "stores";
import { CompanyRole, UserListEntity, UserScope } from "interfaces";
import { Col, Tooltip } from "antd";

import { EditRolesModal } from "./EditRolesModal";
import { ReactComponent as EditIcon } from "images/editIcon.svg";

interface IProps {
  roles: UserScope[];
  companyInfo: {
    id: string;
    role: CompanyRole;
    companyName: string;
    companyRegistrationNumber: string;
  };
  userInfo: UserListEntity;
}

export const EditRolesButton = (props: IProps) => {
  const { actionModals } = useStores();

  const openWalletsModal = () => {
    actionModals.open(() => <EditRolesModal {...props} />, {
      width: "600px",
      noValidation: true,
      title: "Редактировать роли пользователя",
      isOverlayClose: false,
      onApply: () => {
        return Promise.resolve();
      },
    });
  };

  return (
    <Col>
      <Tooltip trigger="hover" title={"Редактировать роли"}>
        <EditIcon
          className="cursor-pointer"
          onClick={(e) => {
            e.stopPropagation();
            openWalletsModal();
          }}
        />
      </Tooltip>
    </Col>
  );
};
